let apJSLoadFlag = {};

// 清除加载标识
function deleteLoadFlag() {
    for (const key in apJSLoadFlag) {
        delete apJSLoadFlag[key];
    }
}

function bussLoading() {

    //初始化 部门标准代码
    // initDeptSC();

    //初始化 我的部门标准代码
    // initMyDeptSC();

    //初始化 用户标准代码
    // initUserSC();

    //初始化 岗位标准代码
    // initPostSC();

    //初始化 角色标准代码
    // initRoleSC();

    // //初始化 产品列表
    // initProdSC();

    // //初始化 产品类型树
    // initProdTypeSC();

    // //初始化 客群
    // initCustGroup();

    // //初始化 客户标签
    // initCustTag();
}

// function initProdTypeSC() {

//     if (apJSLoadFlag["pmos_SC_comm.chng_00003020"]) {
//         return;
//     } else {
//         apJSLoadFlag["pmos_SC_comm.chng_00003020"] = true;
//     }

//     var req2 = { /*classifyType: "2"*/ };
//     var url = sgiConfig.service + "pmosprod/classify/queryClassifyList"; // 产品类型
//     commonClient.simplecall(url, req2, function (res) {
//         if (res && res.head && res.head.code == "0000") {
//             tool.sgiLogger.info('查部产品类型成功 res:', res);
//             let datas = res.body || [], id = "prodClassifyId", pid = "parentClassifyId", treeId = "", virtual = null;
//             ctTrStrByDatacustomMade(datas, id, pid, "classifyName", "pmos_SC_comm.chng_00003020");
//         } else {
//             tool.sgiLogger.error("查产品类型失败 res:", res);
//         }
//     });
// }

// function initProdSC() {


//     if (apJSLoadFlag["pmos_SC_comm.chng_00003021"]) {
//         return;
//     } else {
//         apJSLoadFlag["pmos_SC_comm.chng_00003021"] = true;
//     }

//     var req2 = {};
//     var url = sgiConfig.service + "pomsprod/complete/list3"; // 查询产品列表
//     commonClient.simplecall(url, req2, function (res) {
//         if (res && res.head && res.head.code == "0000") {
//             tool.sgiLogger.info('查产品列表成功 res:', res);
//             let datas = res.body || [];
//             var scCode = "pmos_SC_comm.chng_00003021", list = datas, codeCode = "prodId", textCode = "prodName", noclearFlag = false;
//             tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
//         } else {
//             tool.sgiLogger.error("查产品列表失败 res:", res);
//         }
//     });
// }

function initMyDeptSC() {

    if (apJSLoadFlag["pmos_SC_comm.chng_00003022"]) {
        return;
    } else {
        apJSLoadFlag["pmos_SC_comm.chng_00003022"] = true;
    }

    var req2 = { id: tool.getCookie('deptId') };
    var path2 = sgiConfig.service_baseuam + "/dept/getAllDeptUnderDept"; // 查询用户列表
    commonClient.simplecall(path2, req2, function (res) {
        if (res && res.head && res.head.code == "0000") {
            tool.sgiLogger.info('查部门列表成功 res:', res);
            var scCode = "pmos_SC_comm.chng_00003022", list = res.body || [], codeCode = "id", textCode = "deptName", noclearFlag = false;
            tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
            // let datas = res.body || [], id = "id", pid = "parentId", treeId = "", virtual = null;
            // ctTrStrByDatacustomMade(datas, id, pid, "deptName", "pmos_SC_comm.chng_00003022");
        } else {
            tool.sgiLogger.error("查部门列表失败 res:", res);
        }
    });
}

function initDeptSC() {

    if (apJSLoadFlag["pmos_SC_comm.chng_00001002"]) {
        return;
    } else {
        apJSLoadFlag["pmos_SC_comm.chng_00001002"] = true;
    }

    var req2 = { enterpriseId: tool.getCookie('enterpriseId') };
    var path2 = sgiConfig.service_baseuam + "/dept/getOrganization"; // 查询用户列表
    commonClient.simplecall(path2, req2, function (res) {
        if (res && res.head && res.head.code == "0000") {
            tool.sgiLogger.info('查部门列表成功 res:', res);
            let datas = res.body || [], id = "id", pid = "parentId", treeId = "", virtual = null;
            ctTrStrByDatacustomMade(datas, id, pid, "deptName", "pmos_SC_comm.chng_00001002");
        } else {
            tool.sgiLogger.error("查部门列表失败 res:", res);
        }
    });
}

function initUserSC() {

    if (apJSLoadFlag["pmos_SC_comm.chng_00001001"]) {
        return;
    } else {
        apJSLoadFlag["pmos_SC_comm.chng_00001001"] = true;
    }

    var req2 = { enterpriseId: tool.getCookie('enterpriseId') };
    var path2 = sgiConfig.service_baseuam + "/UamUserInfo/query"; // 查询用户列表
    commonClient.simplecall(path2, req2, function (res) {
        if (res && res.head && res.head.code == "0000") {
            tool.sgiLogger.info('查用户列表成功 res:', res);
            let datas = res.body || [];
            var scCode = "pmos_SC_comm.chng_00001001", list = datas, codeCode = "userId", textCode = "userNickname", noclearFlag = true;
            tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
        } else {
            tool.sgiLogger.error("查用户列表失败 res:", res);
        }
    });
}

function initPostSC() {

    if (apJSLoadFlag["pmos_SC_comm.chng_00001003"]) {
        return;
    } else {
        apJSLoadFlag["pmos_SC_comm.chng_00001003"] = true;
    }


    var req2 = { enterpriseId: tool.getCookie('enterpriseId') };
    var path2 = sgiConfig.service_baseuam + "/post/getPostOfEnterprise"; // 查询岗位id
    commonClient.simplecall(path2, req2, function (res) {
        if (res && res.head && res.head.code == "0000") {
            tool.sgiLogger.info('查用户列表成功 res:', res);
            let datas = res.body || [];
            var scCode = "pmos_SC_comm.chng_00001003", list = datas, codeCode = "postId", textCode = "postName", noclearFlag = false;
            tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
        } else {
            tool.sgiLogger.error("查用户列表失败 res:", res);
        }
    });
}



function initRoleSC() {

    if (apJSLoadFlag["pmos_SC_comm.chng_00003019"]) {
        return;
    } else {
        apJSLoadFlag["pmos_SC_comm.chng_00003019"] = true;
    }

    var req2 = { values: { enterpriseId: tool.getCookie('enterpriseId') }, batch: false };
    var path2 = sgiConfig.service_baseuam + "/role/list"; // 查询角色列表
    commonClient.simplecall(path2, req2, function (res) {
        if (res && res.head && res.head.code == "0000") {
            tool.sgiLogger.info('查用户列表成功 res:', res);
            let datas = res.body || [];
            var scCode = "pmos_SC_comm.chng_00003019", list = datas, codeCode = "roleId", textCode = "roleName", noclearFlag = false;
            tool.setSCList(scCode, list, codeCode, textCode, noclearFlag);
        } else {
            tool.sgiLogger.error("查用户列表失败 res:", res);
        }
    });
}

function ctTrStrByDatacustomMade(datas, id, pid, idName, scguid) {//eoid, 
    if (!datas) {
        return [];
    }
    var tempNodes = datas.concat();

    function createChild(node) {

        //属性赋值给  标准代码
        node.te = node[idName];
        node.c = node[id];

        var curid = node && node[id];
        if (!curid) curid = "";
        var childrenName = "cldSet";
        if (!node[childrenName]) {// 当前node下子节点为空
            node[childrenName] = [];
        }
        for (var i = 0; i < tempNodes.length; i++) {
            var record = tempNodes[i];
            if (!record)
                continue;
            var parentid = record[pid];
            if (!parentid) { parentid = ""; }
            if (parentid == curid) {// 是当前节点的子节点，添加到当前节点下。
                node[childrenName].push(record);
                tempNodes.splice(i, 1);
                i--;
            }
        }
        if (tempNodes.length > 0) {
            var childnodes = node[childrenName];
            if (childnodes) {
                var len = childnodes.length;
                for (var i = 0; i < len; i++) { // 对当前节点的子节点循环添加孙子节点。
                    if (tempNodes.length <= 0) break;
                    createChild(childnodes[i]);
                }
            }
        }
    }
    var treeData = {};
    createChild(treeData);
    // treeData = treeData["cldSet"];


    var scList = StandardCode.getSC(scguid);

    // scList.splice(0, scList.length);

    treeData["cldSet"].forEach(element => {
        scList.push(element);
    });

    return treeData;
}

export { bussLoading, deleteLoadFlag }


// WEBPACK FOOTER //
// ./apps/project/bussInit.js